/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { order, setting } from "@api/Api";

export const getInventoryData = createAsyncThunk(
  "appOrder/getInventoryData",
  async (values) => {
    try {
      return order.getInventoryOrder(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllOrder = createAsyncThunk(
  "appOrder/getAllOrder",
  async (query) => {
    try {
      return order.getOrders(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllOrderSeasonal = createAsyncThunk(
  "appOrder/getAllOrderSeasonal",
  async (query) => {
    try {
      return order.getAllOrderSeasonal(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllMetaDataSeasonal = createAsyncThunk(
  "appOrder/getAllMetaDataSeasonal",
  async (query) => {
    try {
      return order.getMetaDataSeasonal(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllMetaDataOrder = createAsyncThunk(
  "appOrder/getAllMetaDataOrder",
  async (query) => {
    try {
      return order.getMetaData(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllOrderSalePipeline = createAsyncThunk(
  "appOrder/getAllOrderSalePipeline",
  async (query) => {
    try {
      return order.getOrdersSalesPipline(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllMetaDataOrderSalePipeline = createAsyncThunk(
  "appOrder/getAllMetaDataOrderSalePipeline",
  async (query) => {
    try {
      return order.getSalePipelineMetaData(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getOrder = createAsyncThunk("appOrder/getOrder", async (id) => {
  try {
    return order.getOrder(id);
  } catch (error) {
    console.error(error);
  }
});

export const changeFeched = createAsyncThunk(
  "appOrder/changeFeched",
  async (fetch) => {
    try {
      return fetch;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getBillingOrder = createAsyncThunk(
  "appOrder/getBillingOrder",
  async (id) => {
    try {
      return order.getBillingOrder(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addOrder = createAsyncThunk(
  "appOrder/addOrder",
  async ({ user, func }) => {
    try {
      return order.create(user, func);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "appOrder/deleteOrder",
  async (id) => {
    return order.delete(id);
  }
);

export const getAllOrderStatus = createAsyncThunk(
  "appOrder/getAllOrderStatus",
  async () => {
    try {
      return setting.getStatus();
    } catch (error) {
      console.error(error);
    }
  }
);

export const changeStatus = createAsyncThunk(
  "appOrder/changeStatus",
  async (value) => {
    return setting.changeStatus(value);
  }
);

export const updateStatus = createAsyncThunk(
  "appOrder/updateStatus",
  async (value) => {
    return setting.updateStatus(value);
  }
);

export const finalize = createAsyncThunk(
  "appOrder/finalize",
  async (values) => {
    try {
      return order.finalize(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appOrderSlice = createSlice({
  name: "appOrder",
  initialState: {
    order: [],
    orderSeasonal: [],
    orderSeasonalFetched: false,
    orderSalesPipeline: [],
    inventoryOrderData: [],
    orderNoteData: [],
    orderStatus: [],
    orderStatusFetched: false,
    metaData: {},
    metaDataSeasonal: {},
    metaDataSeasonalFetched: false,
    totalMetaData: {},
    metaDataOrderSalesPipeline: {},
    metaDataOrderSalesPipelineFetched: false,
    selectedOrder: {},
    selectedOrderFetch: false,
    billingInfo: {},
    billingInfoFetch: false,
    orderFetched: false,
    orderSalesPipelineFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrder.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.order = [];
          state.inventoryOrderData = [];
          state.selectedOrder = {};
          state.metaData = {};
          state.totalMetaData = {};
          state.metaDataFetched = false;
          state.selectedOrder = {};
          state.inventoryOrderData = [];

          state.orderFetched = false;

          state.selectedOrderFetch = false;
          return;
        }

        state.inventoryOrderData = [];
        state.selectedOrder = {};

        state.order = action.payload?.data?.data;
        state.totalMetaData = action.payload?.data?.total;
        state.orderFetched = true;
        state.orderSalesPipelineFetched = false;
        state.selectedOrderFetch = false;
      })

      .addCase(changeFeched.fulfilled, (state, action) => {
        state.orderFetched = action.payload;
      })

      .addCase(getAllMetaDataOrder.fulfilled, (state, action) => {
        state.metaData = action.payload?.data?.data;
        state.metaDataFetched = true;
      })
      .addCase(getAllOrderSalePipeline.fulfilled, (state, action) => {
        state.selectedOrder = {};
        state.orderSalesPipeline = action.payload?.data?.data;
        state.orderSalesPipelineFetched = true;
        state.selectedOrderFetch = false;

        state.orderFetched = false;
      })
      .addCase(getAllMetaDataOrderSalePipeline.fulfilled, (state, action) => {
        state.metaDataOrderSalesPipeline = action.payload?.data?.metaData;
        state.metaDataOrderSalesPipelineFetched = true;
      })

      .addCase(getAllOrderSeasonal.fulfilled, (state, action) => {
        state.orderSeasonal = action.payload?.data?.data;
        state.orderSeasonalFetched = true;
      })
      .addCase(getAllMetaDataSeasonal.fulfilled, (state, action) => {
        state.metaDataSeasonal = action.payload?.data?.data;
        state.metaDataSeasonalFetched = true;
      })

      .addCase(getInventoryData.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.inventoryOrderData = [];
          return;
        }
        state.inventoryOrderData = action.payload?.data?.data;
      })

      .addCase(getAllOrderStatus.fulfilled, (state, action) => {
        state.orderStatus = action.payload?.data?.data;
        state.orderStatusFetched = true;
      })
      .addCase(getOrder.fulfilled, (state, action) => {
        state.selectedOrder = action.payload?.data?.data;
        state.orderFetched = false;
        state.selectedOrderFetch = true;
        state.orderSalesPipelineFetched = false;
      })

      .addCase(getBillingOrder.fulfilled, (state, action) => {
        if (action.status !== 200) {
          state.billingInfo = {};
          return;
        }
        state.billingInfo = action?.payload?.data?.data;
      })
      .addCase(finalize.fulfilled, (state, action) => {
        state.orderFetched = false;
      });
  },
});

export default appOrderSlice.reducer;
